import Split from 'react-split';

export default Split;